import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { currencyOf, OBJECTIVES, toMinorUnits } from "./marketingFormat";

export default function CreateCampaignDialog({
  open,
  connections,
  defaultConnectionId,
  onClose,
  mutation,
}) {
  const [chosen, setChosen] = useState(null);
  const connectionId = chosen ?? defaultConnectionId ?? connections[0]?.id ?? "";
  const currency = currencyOf(connections, connectionId);
  const [name, setName] = useState("");
  const [objective, setObjective] = useState("OUTCOME_TRAFFIC");
  const [budget, setBudget] = useState("");
  const cents = toMinorUnits(budget);

  const submit = () =>
    mutation.mutate(
      { connectionId, name: name.trim(), objective, dailyBudgetCents: cents },
      {
        onSuccess: () => {
          setName("");
          setBudget("");
          onClose();
        },
      }
    );

  return (
    <Dialog open={open} onClose={mutation.isLoading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>New paused campaign</DialogTitle>
      <DialogContent className="space-y-3">
        <p className="pt-2 text-sm text-app-text-secondary">
          This creates an empty campaign on Meta in a paused state. It has no ads yet, so add an ad
          set and ads in Meta Ads Manager before starting it. To promote an existing post, boost it
          from the Posts tab instead.
        </p>
        {connections.length > 1 ? (
          <TextField
            select
            label="Account"
            value={connectionId}
            onChange={(e) => setChosen(e.target.value)}
            fullWidth
            size="small"
          >
            {connections.map((connection) => (
              <MenuItem key={connection.id} value={connection.id}>
                {connection.label}
              </MenuItem>
            ))}
          </TextField>
        ) : null}
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          size="small"
          inputProps={{ maxLength: 200 }}
        />
        <TextField
          select
          label="Objective"
          value={objective}
          onChange={(e) => setObjective(e.target.value)}
          fullWidth
          size="small"
        >
          {OBJECTIVES.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label={`Daily budget${currency ? ` (${currency})` : ""}`}
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          fullWidth
          size="small"
          helperText="Minimum 1.00. Nothing is spent until the campaign is started."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={mutation.isLoading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!connectionId || !name.trim() || !cents || mutation.isLoading}
          onClick={submit}
        >
          Create paused
        </Button>
      </DialogActions>
    </Dialog>
  );
}
